const initialState = {
  allLabels: [],
  labels: [],
  labelsRest: null,
};

const labelsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_LABELS_SUCCESS":
      return {
        ...state,
        labels: action.payload?.hits,
        labelsRest: action.payload?.rest,
      };
    case "FETCH_ALL_LABELS_SUCCESS":
      return {
        ...state,
        allLabels: action.payload,
      };
    case "UPDATE_LABEL_SUCCESS":
      return {
        ...state,
        labels: state.labels?.map((lab) =>
          lab.id === action.payload.id ? action.payload : lab
        ),
      };
    case "DELETE_LABEL_SUCCESS":
      return {
        ...state,
        labels: state.labels?.filter((label) => label?.id !== action.payload),
      };
    default:
      return state;
  }
};

export default labelsReducer;
